import { store } from 'redux/store';
import { OLDEST_DATE } from 'constants/defaultConstants';
import { getLastOperation } from '../api/getLastOperation';

export const getOperationDate = async (societyId: string) => {
  const lastOperation = await store.dispatch(getLastOperation({ societyId }));

  const lastOperationDate = lastOperation?.date;

  if (!lastOperationDate) {
    return OLDEST_DATE;
  }

  const date = new Date(lastOperationDate as string);
  date.setMinutes(date.getMinutes() + 1);

  return date;
};
